import { createFileRoute } from "@tanstack/react-router";
import HomePageSettings from "@/pages/admin/HomePageSettings";

export const Route = createFileRoute("/admin/homepage-settings")({
  component: HomePageSettings,
});
